import React, {useState} from "react";
import {useHistory} from "react-router";
import Box from "@mui/material/Box";
import "../../utils/auth/auth.css";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import {DiceComponent} from "../board-game/games/generated/components/DiceComponent";


export const JoinLobbyPage = () => {

    const history = useHistory();
    const mobile = window.innerWidth < 700;
    const [lobbyId, setLobbyId] = useState("");

    function handleChange(event) {
        setLobbyId(event.target.value.toUpperCase());
        event.target.value = event.target.value.toUpperCase();
    }

    return (
        <div className={"auth-form"}>
            <form name="form">
                <div className={'form-group'}>
                    <label htmlFor="lobbyId">Join a Lobby</label>
                    <TextField type="text" name="Lobby ID"
                               placeholder="Lobby ID"
                               hiddenLabel
                               size="small"
                               style={{width: "100%"}}
                               variant="outlined" value={lobbyId}
                               onChange={handleChange}/>
                    <div style={{textAlign: "right", marginTop: "1vh", width: "100%"}}>
                        <Button
                            variant="contained"
                            disabled={!lobbyId}
                            onClick={() => history.push("/lobby/" + lobbyId)}>
                            Join
                        </Button>
                    </div>
                </div>
            </form>
        </div>
    )
};
